export default "__VITE_ASSET__WHVsO9GC__"